import { create } from 'zustand'
import { APP_SLUG } from '../config'

/**
 * Tema claro/oscuro del DCC UI Kit. El kit lo activa con `data-dcc-theme` en <html>:
 * "dark" fuerza el oscuro, "auto" sigue al sistema y sin atributo queda en claro.
 * Las piezas de marca (barra lateral, nav, pie) son oscuras en los dos.
 *
 * La elección se guarda por navegador. vite.config.ts la aplica antes del primer
 * pintado con la misma clave, para que la página no parpadee en claro.
 */
export type PreferenciaTema = 'claro' | 'oscuro' | 'sistema'

const CLAVE = `${APP_SLUG}:tema`
const ATRIBUTO: Record<PreferenciaTema, string | null> = { claro: null, oscuro: 'dark', sistema: 'auto' }

function leer(): PreferenciaTema {
  try {
    const valor = localStorage.getItem(CLAVE)
    return valor === 'oscuro' || valor === 'sistema' ? valor : 'claro'
  } catch {
    return 'claro'
  }
}

function aplicar(preferencia: PreferenciaTema) {
  const valor = ATRIBUTO[preferencia]
  if (valor) document.documentElement.setAttribute('data-dcc-theme', valor)
  else document.documentElement.removeAttribute('data-dcc-theme')
}

interface TemaState {
  preferencia: PreferenciaTema
  elegir: (p: PreferenciaTema) => void
}

export const useTema = create<TemaState>((set) => ({
  preferencia: leer(),
  elegir: (preferencia) => {
    try {
      localStorage.setItem(CLAVE, preferencia)
    } catch {
      // Sin localStorage el tema dura hasta recargar.
    }
    aplicar(preferencia)
    set({ preferencia })
  },
}))
